module.exports = __webpack_public_path__ + "static/media/gift-exchanges-v2.fefcbc59.svg";